<template>
  <!-- 全局选择会议室 -->
  <div class="room-wrap">
    <p class="name">
      {{ $t("会议类型") }}
    </p>
    <div class="list">
      <div class="item" :class="{active: props.modelValue == index}" v-for="(item, index) in list" :key="index" @click="emit('update:modelValue', index)">
        <span class="cir"></span>
        <span class="txt">{{ item }}</span>
      </div>
	  <!-- <img src="../../assets/images/joinUs.png" class="join" @click="isJoinTipShow = true" alt="" /> -->
      <!-- <span style="cursor: pointer;" @click="isJoinTipShow = true">{{ $t("加盟与真") }}</span> -->
    </div>
  </div>

  <join-tip :passShow="isJoinTipShow" @closeToast="isJoinTipShow = false"></join-tip>
</template>

<script setup>

// 多语言调用
import {getCurrentInstance, ref} from "vue";

const { appContext : { config: { globalProperties } } } = getCurrentInstance();
// 弹窗
const isJoinTipShow = ref(false);
const props = defineProps({
  modelValue: Number
})

const emit = defineEmits([
  "update:modelValue"
])

const list = [
  // globalProperties.$t("通讯录"),
  globalProperties.$t("虚拟会议室"),
  globalProperties.$t("我的会议室"),
  globalProperties.$t("与真空间")
]

</script>

<style scoped>
.room-wrap .list .join{
	width: 5.83333vw;
	height: 1.35416vw;
	position: absolute;
	right: 0;
	bottom: 0;
	cursor: pointer;
}
.room-wrap {
  width: 30.20833vw;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.room-wrap .name {
  font-size: 0.9375vw;
  line-height: 1.30208vw;
  font-weight: bold;
  color: #2F3367;
  /* margin-bottom: 0.41666vw; */
}

.room-wrap .list {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-left: 1.25vw;
}

.room-wrap .list .item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 2.08333vw;
  cursor: pointer;
}

.room-wrap .list .item .cir {
  display: block;
  width: 1.04166vw;
  height: 1.04166vw;
  box-sizing: border-box;
  border-radius: 50%;
  border: 0.05208vw solid #D4D6D8;
  margin-right: 0.83333vw;
  flex-shrink: 0;
  transition: .1s all ease-in;
}

.room-wrap .list .item .txt {
  font-size: 0.83333vw;
  line-height: 1;
  color: #171A41;
}

.room-wrap .list .item.active .cir {
  border-width: 0.26041vw;
  border-color: #B41D22;
}

@media screen and (max-width: 750px) {
	.room-wrap .list .join{
		width: 20.83333vw;
		height: 5.35416vw;
		position: absolute;
		right: 0;
		bottom: 0;
		cursor: pointer;
	}

  .room-wrap {
    width: 82.93333vw;
	display: unset;
  }

  .room-wrap .name {
    font-size: 3.73333vw;
    line-height: 5.33333vw;
    margin-bottom: 1.6vw;
  }

  .room-wrap .list .item .cir {
    width: 4.26666vw;
    height: 4.26666vw;
    margin-right: 2.13333vw;
  }

  .room-wrap .list .item .txt {
    font-size: 3.73333vw;
  }

  .room-wrap .list .item.active .cir {
    border-width: 1.06666vw;
  }

}
</style>
